import api from './api';
import { Brand, BrandStats } from '../types';

export const brandService = {
  // Brand Management
  getBrand: async (id: number) => {
    const response = await api.get(`/api/brands/${id}?populate=*`);
    return response.data;
  },



  updateBrand: async (id: number, data: Partial<Brand['attributes']>) => {
    const response = await api.put(`/api/brands/${id}`, { data });
    return response.data;
  },

  createBrand: async (data: Partial<Brand['attributes']>) => {
    const response = await api.post('/api/brands', { data });
    return response.data;
  },

  // Brand Statistics
  getBrandStats: async (id: number) => {
    const response = await api.get(`/api/brands/${id}/stats`);
    return response.data;
  },



  // Initialize brand data
  initializeBrand: async (id: number) => {
    const response = await api.post(`/api/brands/${id}/initialize`);
    return response.data;
  },

  // Get all brands (admin only)
  getBrands: async (params?: Record<string, any>) => {
    const response = await api.get('/api/brands', { params });
    return response.data;
  },

  // Upload brand logo
  uploadBrandLogo: async (brandId: number, file: File) => {
    const formData = new FormData();
    formData.append('files', file);
    formData.append('ref', 'api::brand.brand');
    formData.append('refId', brandId.toString());
    formData.append('field', 'logo');

    const response = await api.post('/api/upload', formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
    return response.data;
  },



  // Update subscription
  updateSubscription: async (id: number, subscriptionData: {
    subscriptionPlan: string;
    subscriptionExpiry: string;
    maxUsers: number;
    maxInvoicesPerMonth: number;
  }) => {
    const response = await api.put(`/api/brands/${id}/subscription`, subscriptionData);
    return response.data;
  },

  // Brand User Management (Super Admin)
  getBrandUsers: async (brandId: number, params?: { page?: number; pageSize?: number; search?: string }) => {
    const response = await api.get(`/api/brands/${brandId}/users`, { params });
    return response.data;
  },

  assignUserToBrand: async (brandId: number, userId: number) => {
    const response = await api.post(`/api/brands/${brandId}/users/${userId}`);
    return response.data;
  },

  removeUserFromBrand: async (brandId: number, userId: number) => {
    const response = await api.delete(`/api/brands/${brandId}/users/${userId}`);
    return response.data;
  },

  // Get all users for assignment (not assigned to any brand or available for reassignment)
  getAvailableUsers: async (params?: { page?: number; pageSize?: number; search?: string }) => {
    const response = await api.get('/api/users/available', { params });
    return response.data;
  },

  // Get all users (for super admin brand management)
  getAllUsers: async (params?: { page?: number; pageSize?: number; search?: string; brandId?: number }) => {
    const response = await api.get('/api/users', { params });
    return response.data;
  },
};

export default brandService; 